import * as React from 'react';
import { cva, VariantProps } from 'class-variance-authority';
import { cn } from 'common/utils';

const inputVariants = cva(
  'flex px-2 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      customSize: {
        md: 'rounded py-1.5 text-sm',
        lg: 'rounded-lg py-3 text-base',
      },
      variant: {
        default: 'border border-line-primary',
        underLine:
          'rounded-none border-b border-line-primary bg-transparent text-black-tertiary shadow-none',
        formDefault: 'border border-gray-tertiary bg-white text-black-primary',
        outline: 'w-full border border-line-primary bg-transparent shadow-none',
      },
    },
    defaultVariants: {
      customSize: 'md',
      variant: 'default',
    },
  },
);

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement>,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, customSize, variant, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(inputVariants({ customSize, variant, className }))}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
